/* global euAdminConfig */
import { lookupQuery } from './lookup-result-handler';
import { alert } from './alert';
import _t from './translations';

export const handleDeliverabilityAlert = (deliverabilityType) => {
    let errorLevel;
    let message;
    if (deliverabilityType === 'dkim') {
        errorLevel = 'danger';
        message = _t('Please add required DKIM record to domain to send messages to Gmail and other providers');
    } else if (deliverabilityType === 'spf') {
        errorLevel = 'danger';
        message = _t('Please add required TXT SPF record so messages are not marked as spam in other providers');
    } else if (deliverabilityType === 'dmarc') {
        errorLevel = 'warning';
        message = _t('Please add recommended TXT DMARC record so receiving providers know what to do if DKIM or SPF is misconfigured');
    }

    if (!message) {
        return;
    }

    alert(
        errorLevel,
        message,
        true,
        '#deliverability-alert-wrapper',
        false,
        true,
        `
        <svg class="bi flex-shrink-0 me-2" style="height: 16px;width: 16px;" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
        </svg>
        `
    );

    /*
     * make domain validation status a warning instead of validated if DKIM, SPF or DMARC not configured:
     * display all .deliverability-warning-item and hide all .deliverability-success-item
     */
    const domainMenuEl = document.querySelector(`#menu-container a[data-domain="${euAdminConfig.hostname}"]`);
    if (!domainMenuEl) {
        return;
    }

    // eslint-disable-next-line no-return-assign,no-param-reassign
    domainMenuEl.parentNode.querySelectorAll('.deliverability-warning-item').forEach((el) => el.style.display = 'block');
    // eslint-disable-next-line no-return-assign,no-param-reassign
    domainMenuEl.parentNode.querySelectorAll('.deliverability-success-item').forEach((el) => el.style.display = 'none');
};

export const checkDeliverabilityIssues = () => {
    lookupQuery('cname_dkim', (result) => {
        if (result === 'notValid') {
            handleDeliverabilityAlert('dkim');
        }
    });

    lookupQuery('txt_spf', (result) => {
        if (result === 'notValid') {
            handleDeliverabilityAlert('spf');
        }
    });

    lookupQuery('txt_dmarc', (result) => {
        if (result === 'notValid') {
            handleDeliverabilityAlert('dmarc');
        }
    });
};
